export const colors = [
    'blue.6',
    'pink.6',
    'grape.6',
    'cyan.6',
    'green.6',
    'orange.6',
    'red.6',
    'teal.6',
    'violet.6',
  ];

